<!--登录页-->
<template>
	<div class="loginBg">
		<!-- <img src="../assets/logo@2x.png" class="logoImage"/> -->
		<!-- <div class="slogan">
			<div class="sloganA">德木云链</div>
			<div class="sloganB">高效、协同、赋能</div>
			<img src="../assets/wenzi@2x.png" class="sloaganImage">
		</div> -->
		<img src="../assets/beijing.jpg" class="logoImageBg">
		<div class="copyRight"></div>
		<div class="loginBox">
			<div class="loginBoxBg"></div>
			<div class="loginBoxMess">
				<img src="../assets/logo1.png" class="logoImage"/>
				<div class="welcome">欢迎回家</div>
				<el-form class="form login_form" ref="login" :model="form" :rules="rules">
					<el-form-item prop="username">
						<div class="formTitle">账号</div>
						<el-input v-model="form.username" placeholder='用户名' @keyup.enter.exact.native="login"></el-input>
					</el-form-item>
					<el-form-item prop="password">
						<div class="formTitle">密码</div>
						<el-input type="password" placeholder='密码' v-model="form.password" @keyup.enter.exact.native="login" show-password></el-input>
					</el-form-item>
					<div class="loginType">
						<div class="typeTitle">—— 其他方式登录 ——</div>
						<div class="typeLogo clearfix">
							<img src="../assets/weixin.png" @click="wechatoauth" class="logoTypeImage"/>
							<img src="../assets/phone.png" class="logoTypeImage"/>
						</div>
					</div>
					<!-- <el-form-item>
						<div class="rememberPasswordBox clearfix" @click="isRemember=!isRemember">
							<div :class="['rememberBox',isRemember?'rememberBox_checked':'']"></div>
							<div class="rememberTitle">记住密码</div>
						</div>
					</el-form-item> -->
					<!-- <el-form-item>
						<el-button class="w loginBtn" type="warning" plain @click="login" >登 录</el-button>
					</el-form-item> -->
					<div class="loginBtn" @click="login">登录</div>
					<el-form-item v-if="!is_chrome">
						<el-link :underline="false" type="primary " :href="chrome_url" target="_blank">下载Chrome</el-link>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<!-- <div class="keepRecord">
			<a target="_blank" href=" " style="display:inline-block;text-decoration:none;height:20px;line-height:20px;"><img src="/icon//china.png" style="float:left;"/><p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;"><a style="display:inline-block;text-decoration:none;color:#939393;" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=32058502010566">苏公网安备32058502010566号</a> <a style="display:inline-block;text-decoration:none;color:#939393;" href="http://beian.miit.gov.cn/">苏ICP备20002784号-1</a></p></a>
		</div> -->
	</div>
</template>

<style scoped>
	.keepRecord{width:100%;text-align: center; padding:20px 0;position: fixed;bottom:0;left: 0;right:0;margin:auto;}
	.typeTitle{font-size: 16px;color:#fff;font-size: 12px;padding:20px 0;text-align: center;}
	.typeLogo{text-align: center;}
	.logoTypeImage{display: inline-block;width:25px;margin:0 10px;cursor: pointer;}
	input{-webkit-tap-highlight-color:transparent;}
	input:-internal-autofill-selected{background:none;}
	#app{overflow: auto;}
	.loginBg{width:100%;height:100vh;min-width:700px;min-height: 700px; position: relative; }
	/* background: url('../assets/beijing.png') no-repeat 100% 100%;background-size: 100% auto; */
	.logoImageBg{width:100%;height:100%;position: absolute;top:0;bottom:0;z-index: 0;}
	.logoImage{width:150px;display: block;margin-bottom:20px;}
	.slogan{position: absolute;top:37%;transform: translateY(-50%);left:15%;}
	.sloganA{font-size: 20px;color:white;padding-bottom:15px;font-weight: 600;}
	.sloganB{font-size: 14px;color:white;padding-bottom:15px;font-weight: 600;}
	.sloaganImage{width:500px;display: block;}
	.copyRight{font-size: 12px;color:#eee;position: absolute;bottom:10px;text-align: center;width:100%;}
	.loginBox{width:300px;position: absolute;top:50%;transform: translateY(-50%);right:0;left:0;margin: auto; background:none;padding:30px 15px;border-radius: 5px;z-index:2;}
	.loginTitle{font-size: 20px;font-weight: 600;text-align: center;padding-bottom:30px;}
	.welcome{font-size: 16px;font-weight: 600;color:#fff;}
	.formTitle{line-height: 10px;padding-bottom:5px;font-size: 14px;margin-top:20px;color:#fff;}
	.loginBtn{margin-top:10px;width:100%;background-color: #b21111;color:#fff;font-size: 14px;padding:10px 0;text-align: center;border-radius: 3px;cursor: pointer;}
	.rememberPasswordBox{padding-top:20px;cursor: pointer;}
	.rememberBox{width:14px;height:14px;background-color: #ccc;float: left;margin-right: 7px;position: relative;top:1px;border-radius: 2px;}
	.rememberBox_checked{background:url('../assets/yes.png') no-repeat 100% 100%;background-size: 100% 100%;}
	.rememberTitle{font-size: 13px;float: left;line-height:15px;font-weight: 600;}
	.loginBoxMess{position: relative;z-index: 2;}
	.loginBoxBg{background-color: #fff;width:100%;height: 100%;opacity: 0.2;position: absolute;top:0;left:0;z-index:0;border-radius: 3px;}
</style>

<script>
	export default {
		data() {
			return {
				rules: {
					username: [
						{ required: true, message: '请输入用户名', trigger: 'blur' }
					],
					password: [
						{ required: true, message: '请输入密码', trigger: 'blur' }
					],
				},
				form : {
					username : "",//admin
					password : "",//7opjshme
					company : "", //xiaochengxu
				},
				isRemember:false,
				size:true,
				chrome_url : "",
				is_chrome : false,
			}
		},
		created() {
			document.title = "谱木云";
			this.detectOS();
			// const isProduction = process.env.NODE_ENV === 'production';
			// if (isProduction) {
			// 	let name = location.hostname.split(".").shift();
			// 	this.form.company = name;
			// } else {
            //     }
			// if(this.$getCookie("DEMU_REMEMBER_ACCOUNT")&&this.$getCookie("DEMU_REMEMBER_ACCOUNT")){
            //     this.isRemember=true;
			// 	let account = this.$getCookie("DEMU_REMEMBER_ACCOUNT");
			// 	let pwd = this.$getCookie("DEMU_REMEMBER_PASSWORD");
			// 	this.form.username = account;
			// 	this.form.password = pwd;
			// }
			this.form.company = "test";
			window.addEventListener("storage",this.storageChange)
		},
		mounted(){
			window.addEventListener('resize', this.handler)
		},
		methods: {
			storageChange(e){
				if(e.key == "PUMU_WECHAT_LOGIN_MESSAGE" && e.newValue.length > 0){
					let json = JSON.parse(e.newValue);
					if(json.code && json.state){
						this.wechatlogin(json);
					}
					localStorage.removeItem("PUMU_WECHAT_LOGIN_MESSAGE")
				}
				
			},
			wechatoauth(){
				let redirect_uri = location.origin + "/wechatlogin";
				this.postFunc("/erp/wx.oauth",{redirect_uri:redirect_uri},res=>{
					window.open(res.data.data)
				},error=>{
					this.tip(error.data.message,"warning")
				})
			},
			wechatlogin(json){
				this.postFunc("/erp/user.wechatLogin",json,response=>{
					this.setLocalStorge(response)
				},error=>{
					this.tip(error.data.message,"warning")
				});
			},
			handler(e){
				if(e.currentTarget.innerWidth/e.currentTarget.innerHeight<1.98){
					this.size=false;
				}else{
					this.size=true;
				}
			},
			login(){
				this.$refs.login.validate((valid) => {
					if (valid) {
						const isProduction = process.env.NODE_ENV === 'production';
						if (isProduction) {
							let name = location.hostname.split(".").shift();
							this.form.company = name;
						} else {
							this.form.company = process.env.VUE_APP_COMPAMY;
						}
						this.postFunc("/erp/user.login",this.form,response=>{
                            this.setLocalStorge(response)
                        },error=>{
							this.tip(error.data.message,"warning")
						});
					} else {
						return false;
					}
				});
			},
			detectOS() {
				var sUserAgent = navigator.userAgent;
				this.is_chrome = (sUserAgent.indexOf("Chrome") > -1 || sUserAgent.indexOf("Safari") > -1) && sUserAgent.indexOf("Edge") < 0;
				var isWin = (navigator.platform == "Win32") || (navigator.platform == "Windows");
				var isMac = (navigator.platform == "Mac68K") || (navigator.platform == "MacPPC") || (navigator.platform == "Macintosh") || (navigator.platform == "MacIntel");
				if (isMac) {
					this.chrome_url = "https://dm-erp-public.oss-cn-hangzhou.aliyuncs.com/browser/googlechrome.dmg";
				}
				if (isWin) {
					this.chrome_url = "https://dm-erp-public.oss-cn-hangzhou.aliyuncs.com/browser/ChromeSetup.exe";
				}
			}
		},
		watch:{
			size(){
			}
		},
		beforeDestroy(){
			window.removeEventListener('storage', this.storageChange)
		}
	}
</script>
